<template>
  <detail-layout-full-width>
    <template slot="header">
      <base-header
        icon="user"
        :content="header"
      />
    </template>
    <template slot="main">
      <div class="form-wrapper">
        <el-form
          :model="form"
          :rules="rules"
          ref="ruleForm"
        >
        <div class="lg:max-w-detail lg:mr-auto">
          <div class="mb-6">
            <label for="switch-horario-activo" class="text-sm font-semibold text-secondary-600 block mb-2 flex flex-col">
              {{$t('clients.horario_descarga_activo')}}
              <span class="sr-only">{{$t('app.options')}}: {{$t('app.inactive')}} / {{$t('app.active')}}</span>
            </label>
            <el-switch 
              id="switch-horario-activo"
              :aria-label="$t('clients.horario_descarga_activo')"
              class="switch-text break-normal both-switch mt-2" 
              v-model="form.activo" 
              :active-text="$t('companies.active')"/>
          </div>

          <div class="mb-6">
            <label class="text-sm font-semibold text-secondary-600 block mb-4">{{$t('clients.horario_descarga_dias')}}</label>
            <div>
              <div class="flex flex-col md:flex-row items-start md:items-center mb-2 gap-x-6">
                <label for="switch-lunes" class="flex flex-row items-center gap-x-6 mb-2 md:mb-0" :aria-label="$t('days.monday')">
                  <span class="sr-only">{{$t('days.monday')}}. {{$t('app.options')}}: {{$t('app.inactive')}} / {{$t('app.active')}}</span>
                  <el-switch 
                    id="switch-lunes"
                    :aria-label="$t('days.monday')"
                    class="switch-text break-normal both-switch w-40" 
                    v-model="form.lunes.activo" 
                    :active-text="$t('days.monday')"
                    />
                </label>
                <el-form-item prop="rangoHorasDescarga" class="mb-0">
                  <el-time-picker
                    class="fix-width-single mr-2"
                    :class="{'time-picker-active': form.lunes.activo}"
                    disabled
                    :clearable="false"
                    format="HH:mm"
                    :placeholder="form.lunes.activo 
                      ? form.lunes.range 
                        ? this.defaultInitialHour
                        : this.defaultDisabledMsg 
                      : this.defaultAllDayMsg"
                    >
                  </el-time-picker>
                  <span class="mr-2">-</span>
                  <label>
                    <el-time-picker
                      aria-label="Hora máxima del lunes"
                      class="fix-width-single"
                      :class="{'time-picker-active': form.lunes.activo}"
                      :disabled="!form.lunes.activo"
                      :clearable="false"
                      format="HH:mm"
                      v-model="form.lunes.range"
                      :placeholder="form.lunes.activo ? 'Todo el día' : 'Sin descargas'"
                      >
                    </el-time-picker>
                  </label>
                  <base-clear-input-button
                    v-if="form.lunes.range"
                    aria-label="Limpiar hora máxima del lunes"
                    @clear="form.lunes.range = null"
                  />
                </el-form-item>
              </div>

              <div class="flex flex-col md:flex-row items-start md:items-center mb-2 gap-x-6">
                <label for="switch-martes" class="flex flex-row items-center gap-x-6 mb-2 md:mb-0" :aria-label="$t('days.tuesday')">
                  <span class="sr-only">{{$t('days.tuesday')}}. {{$t('app.options')}}: {{$t('app.inactive')}} / {{$t('app.active')}}</span>
                  <el-switch 
                    id="switch-martes"
                    :aria-label="$t('days.tuesday')"
                    class="switch-text break-normal both-switch w-40" 
                    v-model="form.martes.activo" 
                    :active-text="$t('days.tuesday')"
                    />
                </label>
                <el-form-item prop="rangoHorasDescarga" class="mb-0">
                  <el-time-picker
                    class="fix-width-single mr-2"
                    :class="{'time-picker-active': form.martes.activo}"
                    disabled
                    :clearable="false"
                    format="HH:mm"
                    :placeholder="form.martes.activo 
                      ? form.martes.range 
                        ? this.defaultInitialHour
                        : this.defaultDisabledMsg 
                      : this.defaultAllDayMsg"
                    >
                  </el-time-picker>
                  <span class="mr-2">-</span>
                  <label>
                    <el-time-picker
                      aria-label="Hora máxima del martes"
                      class="fix-width-single"
                      :class="{'time-picker-active': form.martes.activo}"
                      :disabled="!form.martes.activo"
                      :clearable="false"
                      format="HH:mm"
                      v-model="form.martes.range"
                      :placeholder="form.martes.activo ? 'Todo el día' : 'Sin descargas'"
                      >
                    </el-time-picker>
                  </label>
                  <base-clear-input-button
                    v-if="form.martes.range"
                    aria-label="Limpiar hora máxima del martes"
                    @clear="form.martes.range = null"
                  />
                </el-form-item>
              </div>
              
              <div class="flex flex-col md:flex-row items-start md:items-center mb-2 gap-x-6">
                <label for="switch-miercoles" class="flex flex-row items-center gap-x-6 mb-2 md:mb-0" :aria-label="$t('days.wednesday')">
                  <span class="sr-only">{{$t('days.wednesday')}}. {{$t('app.options')}}: {{$t('app.inactive')}} / {{$t('app.active')}}</span>
                  <el-switch 
                    id="switch-miercoles"
                    :aria-label="$t('days.wednesday')"
                    class="switch-text break-normal both-switch w-40" 
                    v-model="form.miercoles.activo" 
                    :active-text="$t('days.wednesday')"
                    />
                </label>
                <el-form-item prop="rangoHorasDescarga" class="mb-0">
                  <el-time-picker
                    class="fix-width-single mr-2"
                    :class="{'time-picker-active': form.miercoles.activo}"
                    disabled
                    :clearable="false"
                    format="HH:mm"
                    :placeholder="form.miercoles.activo 
                      ? form.miercoles.range 
                        ? this.defaultInitialHour
                        : this.defaultDisabledMsg 
                      : this.defaultAllDayMsg"
                    >
                  </el-time-picker>
                  <span class="mr-2">-</span>
                  <label>
                    <el-time-picker
                      aria-label="Hora máxima del miércoles"
                      class="fix-width-single"
                      :class="{'time-picker-active': form.miercoles.activo}"
                      :disabled="!form.miercoles.activo"
                      :clearable="false"
                      format="HH:mm"
                      v-model="form.miercoles.range"
                      :placeholder="form.miercoles.activo ? 'Todo el día' : 'Sin descargas'"
                      >
                    </el-time-picker>
                  </label>
                  <base-clear-input-button
                    v-if="form.miercoles.range"
                    aria-label="Limpiar hora máxima del miercoles"
                    @clear="form.miercoles.range = null"
                  />
                </el-form-item>
              </div>
              
              <div class="flex flex-col md:flex-row items-start md:items-center mb-2 gap-x-6">
                <label for="switch-jueves" class="flex flex-row items-center gap-x-6 mb-2 md:mb-0" :aria-label="$t('days.thursday')">
                  <span class="sr-only">{{$t('days.thursday')}}. {{$t('app.options')}}: {{$t('app.inactive')}} / {{$t('app.active')}}</span>
                  <el-switch 
                    id="switch-jueves"
                    :aria-label="$t('days.thursday')"
                    class="switch-text break-normal both-switch w-40" 
                    v-model="form.jueves.activo" 
                    :active-text="$t('days.thursday')"
                    />
                </label>
                <el-form-item prop="rangoHorasDescarga" class="mb-0">
                  <el-time-picker
                    class="fix-width-single mr-2"
                    :class="{'time-picker-active': form.jueves.activo}"
                    disabled
                    :clearable="false"
                    format="HH:mm"
                    :placeholder="form.jueves.activo 
                      ? form.jueves.range 
                        ? this.defaultInitialHour
                        : this.defaultDisabledMsg 
                      : this.defaultAllDayMsg"
                    >
                  </el-time-picker>
                  <span class="mr-2">-</span>
                  <label>
                    <el-time-picker
                      aria-label="Hora máxima del jueves"
                      class="fix-width-single"
                      :class="{'time-picker-active': form.jueves.activo}"
                      :disabled="!form.jueves.activo"
                      :clearable="false"
                      format="HH:mm"
                      v-model="form.jueves.range"
                      :placeholder="form.jueves.activo ? 'Todo el día' : 'Sin descargas'"
                      >
                    </el-time-picker>
                  </label>
                  <base-clear-input-button
                    v-if="form.jueves.range"
                    aria-label="Limpiar hora máxima del jueves"
                    @clear="form.jueves.range = null"
                  />
                </el-form-item>
              </div>
              
              <div class="flex flex-col md:flex-row items-start md:items-center mb-2 gap-x-6">
                <label for="switch-viernes" class="flex flex-row items-center gap-x-6 mb-2 md:mb-0" :aria-label="$t('days.friday')">
                  <span class="sr-only">{{$t('days.friday')}}. {{$t('app.options')}}: {{$t('app.inactive')}} / {{$t('app.active')}}</span>
                  <el-switch 
                    id="switch-viernes"
                    :aria-label="$t('days.friday')"
                    class="switch-text break-normal both-switch w-40" 
                    v-model="form.viernes.activo" 
                    :active-text="$t('days.friday')"
                    />
                </label>
                <el-form-item prop="rangoHorasDescarga" class="mb-0">
                  <el-time-picker
                    class="fix-width-single mr-2"
                    :class="{'time-picker-active': form.viernes.activo}"
                    disabled
                    :clearable="false"
                    format="HH:mm"
                    :placeholder="form.viernes.activo 
                      ? form.viernes.range 
                        ? this.defaultInitialHour
                        : this.defaultDisabledMsg 
                      : this.defaultAllDayMsg"
                    >
                  </el-time-picker>
                  <span class="mr-2">-</span>
                  <label>
                    <el-time-picker
                      aria-label="Hora máxima del viernes"
                      class="fix-width-single"
                      :class="{'time-picker-active': form.viernes.activo}"
                      :disabled="!form.viernes.activo"
                      :clearable="false"
                      format="HH:mm"
                      v-model="form.viernes.range"
                      :placeholder="form.viernes.activo ? 'Todo el día' : 'Sin descargas'"
                      >
                    </el-time-picker>
                  </label>
                  <base-clear-input-button
                    v-if="form.viernes.range"
                    aria-label="Limpiar hora máxima del viernes"
                    @clear="form.viernes.range = null"
                  />
                </el-form-item>
              </div>
              
              <div class="flex flex-col md:flex-row items-start md:items-center mb-2 gap-x-6">
                <label for="switch-sabado" class="flex flex-row items-center gap-x-6 mb-2 md:mb-0" :aria-label="$t('days.saturday')">
                  <span class="sr-only">{{$t('days.saturday')}}. {{$t('app.options')}}: {{$t('app.inactive')}} / {{$t('app.active')}}</span>
                  <el-switch 
                    id="switch-sabado"
                    :aria-label="$t('days.saturday')"
                    class="switch-text break-normal both-switch w-40" 
                    v-model="form.sabado.activo" 
                    :active-text="$t('days.saturday')"
                    />
                </label>
                <el-form-item prop="rangoHorasDescarga" class="mb-0">
                  <el-time-picker
                    class="fix-width-single mr-2"
                    :class="{'time-picker-active': form.sabado.activo}"
                    disabled
                    :clearable="false"
                    format="HH:mm"
                    :placeholder="form.sabado.activo 
                      ? form.sabado.range 
                        ? this.defaultInitialHour
                        : this.defaultDisabledMsg 
                      : this.defaultAllDayMsg"
                    >
                  </el-time-picker>
                  <span class="mr-2">-</span>
                  <label>
                    <el-time-picker
                      aria-label="Hora máxima del sábado"
                      class="fix-width-single"
                      :class="{'time-picker-active': form.sabado.activo}"
                      :disabled="!form.sabado.activo"
                      :clearable="false"
                      format="HH:mm"
                      v-model="form.sabado.range"
                      :placeholder="form.sabado.activo ? 'Todo el día' : 'Sin descargas'"
                      >
                    </el-time-picker>
                  </label>
                  <base-clear-input-button
                    v-if="form.sabado.range"
                    aria-label="Limpiar hora máxima del sabado"
                    @clear="form.sabado.range = null"
                  />
                </el-form-item>
              </div>
              
              <div class="flex flex-col md:flex-row items-start md:items-center mb-2 gap-x-6">
                <label for="switch-domingo" class="flex flex-row items-center gap-x-6 mb-2 md:mb-0" :aria-label="$t('days.sunday')">
                  <span class="sr-only">{{$t('days.sunday')}}. {{$t('app.options')}}: {{$t('app.inactive')}} / {{$t('app.active')}}</span>
                  <el-switch 
                    id="switch-domingo"
                    :aria-label="$t('days.sunday')"
                    class="switch-text break-normal both-switch w-40" 
                    v-model="form.domingo.activo" 
                    :active-text="$t('days.sunday')"
                    />
                </label>
                <el-form-item prop="rangoHorasDescarga" class="mb-0">
                  <el-time-picker
                    class="fix-width-single mr-2"
                    :class="{'time-picker-active': form.domingo.activo}"
                    disabled
                    :clearable="false"
                    format="HH:mm"
                    :placeholder="form.domingo.activo 
                      ? form.domingo.range 
                        ? this.defaultInitialHour
                        : this.defaultDisabledMsg 
                      : this.defaultAllDayMsg"
                    >
                  </el-time-picker>
                  <span class="mr-2">-</span>
                  <label>
                    <el-time-picker
                      aria-label="Hora máxima del domingo"
                      class="fix-width-single"
                      :class="{'time-picker-active': form.domingo.activo}"
                      :disabled="!form.domingo.activo"
                      :clearable="false"
                      format="HH:mm"
                      v-model="form.domingo.range"
                      :placeholder="form.domingo.activo ? 'Todo el día' : 'Sin descargas'"
                      >
                    </el-time-picker>
                  </label>
                  <base-clear-input-button
                    v-if="form.domingo.range"
                    aria-label="Limpiar hora máxima del domingo"
                    @clear="form.domingo.range = null"
                  />
                </el-form-item>
              </div>
              
            </div>            
          </div>
        </div>
        </el-form>
      </div>
      </template>
    <template slot="layout-extend">
      <base-footer>
        <template slot="actions">
          <base-button-responsive mode="secondary" :text="isFromClient ? $t('app.cancel') : $t('app.back')" icon="cross" @click="goBack" :loading="isGeneralLoading"/>
          <base-button-responsive mode="primary" :text="$t('app.save')" icon="save" @click="submitForm('ruleForm')" :loading="isGeneralLoading" :disabled="isGeneralLoading"/>
        </template>
      </base-footer>
    </template>
  </detail-layout-full-width>
</template>

<script>
import DetailLayoutFullWidth from '../../components/layout/DetailLayoutFullWidth.vue'
import { getDownloadSchedule } from '@/services/clients/getDownloadSchedule'
import { updateDownloadSchedule } from '@/services/clients/updateDownloadSchedule'
import { i18n } from '@/i18n'

import { getClient } from '@/services/clients/getClient'

export default {
  /* eslint-disable camelcase */
  name: 'download-schedule-detail',
  components: {
    DetailLayoutFullWidth,
  },
  data: function () {
    return {
      activeName: 'es',
      header: {
        title: i18n.t('clients.horario_descarga_header'),
        icon: 'config',
        breadcrumb: {},
        nav: [],
        url: this.isFromClient ? 'configurations/clients/details' : 'configurations',
      },
      defaultAllDayMsg: 'Sin descargas',
      defaultDisabledMsg: 'Todo el día',
      defaultInitialHour: '00:00',
      form: {
        activo: false,
        lunes: {
          activo: false,
          range: null,
        },
        martes: {
          activo: false,
          range: null,
        },
        miercoles: {
          activo: false,
          range: null,
        },
        jueves: {
          activo: false,
          range: null,
        },
        viernes: {
          activo: false,
          range: null,
        },
        sabado: {
          activo: false,
          range: null,
        },
        domingo: {
          activo: false,
          range: null,
        },
      },
      rules: {
      }
    }
  },
  computed: {
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    id () {
      return this.$route.params.id ? this.$route.params.id : -1
    },
    isFromClient () {
      return this.id !== -1
    }
  },
  watch: {
    form: {
      deep: true,
      immediate: true,
      handler: 'watchFormHandler'
    },
    'form.lunes.activo': function (value, oldValue) {
      if (!value) this.form.lunes.range = null
    },
    'form.martes.activo': function (value, oldValue) {
      if (!value) this.form.martes.range = null
    },
    'form.miercoles.activo': function (value, oldValue) {
      if (!value) this.form.miercoles.range = null
    },
    'form.jueves.activo': function (value, oldValue) {
      if (!value) this.form.jueves.range = null
    },
    'form.viernes.activo': function (value, oldValue) {
      if (!value) this.form.viernes.range = null
    },
    'form.sabado.activo': function (value, oldValue) {
      if (!value) this.form.sabado.range = null
    },
    'form.domingo.activo': function (value, oldValue) {
      if (!value) this.form.domingo.range = null
    },
  },
  created: async function () {
    const breadcrumbs = []

    if (this.isFromClient) {
      breadcrumbs.push({
        path: this.role === 'SuperAdministrador' ? 'configurationssa' : 'configurations',
        name: this.$i18n.t('app.configurations')
      })
      breadcrumbs.push({
        path: 'configurations/clients',
        name: this.$i18n.t('app.clients')
      })
      if (this.$store.getters['app/fromRouteName'] !== null) {
        const breadcrumbHeader = this.$store.getters['app/headerBreadCrumb']
        breadcrumbs.push({ path: '', name: breadcrumbHeader })
      } else {
        const cliente = await this.downloadClientData(this.id)
        breadcrumbs.push({ path: '', name: cliente.empresa.Nombre })
        this.$store.commit('app/setheaderBreadCrumb', cliente.empresa.Nombre)
      }
    }

    this.header.breadcrumb = breadcrumbs

    const data = await this.downloadData(this.id)
    this.setData(data)
  },
  mounted () {
    this.header.url = this.isFromClient ? 'configurations/clients/details' : 'configurations'
    this.resetControlFormChanges()
  },
  methods: {
    watchFormHandler () {
      this.$store.commit('app/setFormChanges', true)
    },
    downloadClientData: async function (id) {
      let client = null
      try {
        this.$store.commit('setIsLoading', true)
        const params = {
          idEmpresa: id
        }
        client = await getClient(params)
        if (client.blnError === true) {
          this.doFeedback(client.msgError + ' [Código de error: ' + client.codError + ']')
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
      return client
    },
 
    submitForm: function (formName) {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      this.$refs[formName].validate(async valid => {
        if (valid) {
          const payload = this.getPayloadFromForm()
          const response = await updateDownloadSchedule(null, payload)
          if (response.blnError === true) {
            this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
          } else {
            this.doFeedback('Datos actualizados correctamente', 'success')
            this.resetControlFormChanges()
          }
        } else {
          this.doFeedback('Error al procesar los datos, revise la información')
        }
        this.$store.commit('setIsLoading', false)
      })
    },
    goBack: function () {
      if (this.isFromClient) this.$router.push({ name: 'configurations/clients/details', params: this.id })
      else this.$router.push({ name: 'configurations/general' })
    },
    downloadData: async function (id) {
      try {
        this.$store.commit('setIsLoading', true)
        const template = await getDownloadSchedule({ idCliente: this.id })
        if (template.blnError === true) {
          this.doFeedback(template.msgError + ' [Código de error: ' + template.codError + ']')
        } else {
          return template
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
      return null
    },
    setData: function (data) {
      if (data) {
        this.form.activo = data.Activo

        this.form.lunes.activo = data.Horario?.Lunes?.Activo
        this.form.martes.activo = data.Horario?.Martes?.Activo
        this.form.miercoles.activo = data.Horario?.Miercoles?.Activo
        this.form.jueves.activo = data.Horario?.Jueves?.Activo
        this.form.viernes.activo = data.Horario?.Viernes?.Activo
        this.form.sabado.activo = data.Horario?.Sabado?.Activo
        this.form.domingo.activo = data.Horario?.Domingo?.Activo

        if (data.Horario?.Lunes?.HoraFin) {
          this.form.lunes.range = this.generateDateAux(data.Horario?.Lunes.HoraFin)
        } else {
          this.form.lunes.range = null
        }

        if (data.Horario?.Martes?.HoraFin) {
          this.form.martes.range = this.generateDateAux(data.Horario?.Martes.HoraFin)
        } else {
          this.form.martes.range = null
        }

        if (data.Horario?.Miercoles?.HoraFin) {
          this.form.miercoles.range = this.generateDateAux(data.Horario?.Miercoles.HoraFin)
        } else {
          this.form.miercoles.range = null
        }

        if (data.Horario?.Jueves?.HoraFin) {
          this.form.jueves.range = this.generateDateAux(data.Horario?.Jueves.HoraFin)
        } else {
          this.form.jueves.range = null
        }

        if (data.Horario?.Viernes?.HoraFin) {
          this.form.viernes.range = this.generateDateAux(data.Horario?.Viernes.HoraFin)
        } else {
          this.form.viernes.range = null
        }

        if (data.Horario?.Sabado?.HoraFin) {
          this.form.sabado.range = this.generateDateAux(data.Horario?.Sabado.HoraFin)
        } else {
          this.form.sabado.range = null
        }

        if (data.Horario?.Domingo?.HoraFin) {
          this.form.domingo.range = this.generateDateAux(data.Horario?.Domingo.HoraFin)
        } else {
          this.form.domingo.range = null
        }
      }
      this.resetControlFormChanges()
    },
    generateDateAux (dataHora) {
      return new Date(
        new Date().getFullYear(), 
        2, 
        2, 
        dataHora.Horas,
        dataHora.Minutos,
        0,
      )
    },
    getPayloadFromForm () {
      const payload = {
        idCliente: this.id,
        Activo: this.form.activo,
        Horario: {},
      }
      if (this.form.lunes.activo) {
        payload.Horario.Lunes = {}
        payload.Horario.Lunes.Activo = true
        if (this.form.lunes.range) {
          const dateFin = this.form.lunes.range
          payload.Horario.Lunes.HoraFin = {
            Horas: dateFin.getHours(),
            Minutos: dateFin.getMinutes(),
          }
        }
      }
      if (this.form.martes.activo) {
        payload.Horario.Martes = {}
        payload.Horario.Martes.Activo = true
        if (this.form.martes.range) {
          const dateFin = this.form.martes.range
          payload.Horario.Martes.HoraFin = {
            Horas: dateFin.getHours(),
            Minutos: dateFin.getMinutes(),
          }
        }
      }
      if (this.form.miercoles.activo) {
        payload.Horario.Miercoles = {}
        payload.Horario.Miercoles.Activo = true
        if (this.form.miercoles.range) {
          const dateFin = this.form.miercoles.range
          payload.Horario.Miercoles.HoraFin = {
            Horas: dateFin.getHours(),
            Minutos: dateFin.getMinutes(),
          }
        }
      }
      if (this.form.jueves.activo) {
        payload.Horario.Jueves = {}
        payload.Horario.Jueves.Activo = true
        if (this.form.jueves.range) {
          const dateFin = this.form.jueves.range
          payload.Horario.Jueves.HoraFin = {
            Horas: dateFin.getHours(),
            Minutos: dateFin.getMinutes(),
          }
        }
      }
      if (this.form.viernes.activo) {
        payload.Horario.Viernes = {}
        payload.Horario.Viernes.Activo = true
        if (this.form.viernes.range) {
          const dateFin = this.form.viernes.range
          payload.Horario.Viernes.HoraFin = {
            Horas: dateFin.getHours(),
            Minutos: dateFin.getMinutes(),
          }
        }
      }
      if (this.form.sabado.activo) {
        payload.Horario.Sabado = {}
        payload.Horario.Sabado.Activo = true
        if (this.form.sabado.range) {
          const dateFin = this.form.sabado.range
          payload.Horario.Sabado.HoraFin = {
            Horas: dateFin.getHours(),
            Minutos: dateFin.getMinutes(),
          }
        }
      }

      if (this.form.domingo.activo) {
        payload.Horario.Domingo = {}
        payload.Horario.Domingo.Activo = true
        if (this.form.domingo.range) {
          const dateFin = this.form.domingo.range
          payload.Horario.Domingo.HoraFin = {
            Horas: dateFin.getHours(),
            Minutos: dateFin.getMinutes(),
          }
        }
      }
      return payload
    }
  }

}
</script>
